/* Detecta se o arrasto e mais horizontal do que vertical dentro da
   caixa de cores, e nesse caso bloqueia o scroll vertical da pagina
   enquanto dura o gesto, para as cores deslizarem sem mexer a pagina. */
(function () {
  function setup(el) {
    if (el.__kaellinLockSetup) return;
    el.__kaellinLockSetup = true;

    var startX = 0, startY = 0, lockedHorizontal = false, decided = false;

    el.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      decided = false;
      lockedHorizontal = false;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      if (!decided) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          decided = true;
          lockedHorizontal = Math.abs(dx) > Math.abs(dy);
        }
      }

      if (lockedHorizontal && e.cancelable) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  function init() {
    document
      .querySelectorAll('.radio__fieldset--swatches .radio__buttons[data-variant-buttons]')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
